var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v(_vm._s(_vm.PageTitle))])])]),_c('graph'),_c('linear')],1)}
var staticRenderFns = []

export { render, staticRenderFns }